export const HEADERS = ['No.', 'Label', 'Type', 'Actions'];
